<template>
  <div class="fermenter-icon">
    <img v-if="fermenter.id === 1 || fermenter.id === 10 || fermenter.id === 8 || fermenter.id === 9" class="fermenter-icon" src="@/assets/images/wood-fermenter-icon.svg" />
    <img v-if="fermenter.id === 3 || fermenter.id === 7" class="fermenter-icon stone" src="@/assets/images/stone-icon.svg" />
    <img v-if="fermenter.id === 4" class="fermenter-icon" src="@/assets/images/leather-icon.svg" />
    <img v-if="fermenter.id === 5" class="fermenter-icon plastic" src="@/assets/images/plastic-icon.svg" />
    <img v-if="fermenter.id === 6" class="fermenter-icon" src="@/assets/images/stainless-fermenter-icon.svg" />
    <img v-if="fermenter.id === 2" class="fermenter-icon" src="@/assets/images/clay-pot-icon.svg" />

  </div>
</template>

<script>

export default {
  name: 'FermenterIcon',
  mounted(){

  },
  components: {
  },
  computed: {
    
  },
  props: {
    fermenter: Object,
  },
  data(){
    return {
      
    }
  },
  methods: {

  }
}
</script>



<style lang="scss" scoped>


.fermenter-icon {
  height: 28px;
  width: 28px;
  display: inline-block;
  margin-left: 1px;
}

// .stone {
//   margin-left: 0px;
// }

// .plastic {
//   margin-left: .5px;
// }


</style>
